import { render, staticRenderFns } from "./ProductRatingFeedback.vue?vue&type=template&id=2cf9dff2&scoped=true"
import script from "./ProductRatingFeedback.vue?vue&type=script&lang=js"
export * from "./ProductRatingFeedback.vue?vue&type=script&lang=js"
import style0 from "./ProductRatingFeedback.vue?vue&type=style&index=0&id=2cf9dff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9dff2",
  null
  
)

export default component.exports